// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2024 1C-Soft LLC and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.theia-split-widget > .p-SplitPanel {
  height: 100%;
  width: 100%;
  outline: none;
}

.theia-split-widget > .p-SplitPanel > .p-SplitPanel-child {
  min-width: 50px;
  min-height: var(--theia-content-line-height);
}

.theia-split-widget > .p-SplitPanel > .p-SplitPanel-handle {
  box-sizing: border-box;
}

.theia-split-widget > .p-SplitPanel[data-orientation="horizontal"] > .p-SplitPanel-handle {
  border-left: var(--theia-border-width) solid var(--theia-sideBarSectionHeader-border);
}

.theia-split-widget > .p-SplitPanel[data-orientation="vertical"] > .p-SplitPanel-handle {
  border-top: var(--theia-border-width) solid var(--theia-sideBarSectionHeader-border);
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@theia/core/src/browser/style/split-widget.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qFAAqF;AACvF;;AAEA;EACE,oFAAoF;AACtF","sourcesContent":["/********************************************************************************\n * Copyright (C) 2024 1C-Soft LLC and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.theia-split-widget > .p-SplitPanel {\n  height: 100%;\n  width: 100%;\n  outline: none;\n}\n\n.theia-split-widget > .p-SplitPanel > .p-SplitPanel-child {\n  min-width: 50px;\n  min-height: var(--theia-content-line-height);\n}\n\n.theia-split-widget > .p-SplitPanel > .p-SplitPanel-handle {\n  box-sizing: border-box;\n}\n\n.theia-split-widget > .p-SplitPanel[data-orientation=\"horizontal\"] > .p-SplitPanel-handle {\n  border-left: var(--theia-border-width) solid var(--theia-sideBarSectionHeader-border);\n}\n\n.theia-split-widget > .p-SplitPanel[data-orientation=\"vertical\"] > .p-SplitPanel-handle {\n  border-top: var(--theia-border-width) solid var(--theia-sideBarSectionHeader-border);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
